export type TooltipPageType =
	| 'dashboard'
	| 'transactions'
	| 'analytics'
	| 'developer-integration'
	| 'developer-business'
	| 'developer-webhook-logs'
	| 'wallet'
	| 'addresses'
	| 'withdrawals'
	| 'settings'
	| 'profile-information'
	| 'crypto-settings'
	| 'security'
	| 'update-pin'
	| 'reset-pin'
	| 'mfa-factor-authentication'
	| 'change-password'
	| 'activity-log'
	| 'automatic-settlement'
	| 'team-management';

export const pageDataMap: Record<TooltipPageType, { label: string; description: string; link: string }> = {
	'analytics': {
		label: 'Analytics',
		description: '',
		link: '',
	},
	'developer-integration': {
		label: 'Developer - Integration',
		description:
			'Configure and manage your API integration tools in one place. Set up webhook URLs, manage API keys and withdrawal addresses, view transaction fees and markup settings, and monitor webhook delivery logs to support secure, efficient, and reliable integrations',
		link: '',
	},
	'dashboard': {
		label: 'Home',
		description: '',
		link: '',
	},
	'transactions': {
		label: 'Transactions',
		description: '',
		link: '',
	},
	'activity-log': {
		label: 'Activity Log',
		description: '',
		link: '',
	},
	'addresses': {
		label: 'Addresses',
		description: '',
		link: '',
	},
	'automatic-settlement': {
		label: 'Automatic Settlement',
		description: '',
		link: '',
	},
	'change-password': {
		label: 'Change Password',
		description: '',
		link: '',
	},
	'crypto-settings': {
		label: 'Crypto Settings',
		description: '',
		link: '',
	},
	'developer-business': {
		label: 'Developer - Business',
		description: '',
		link: '',
	},
	'developer-webhook-logs': {
		label: 'Developer - Webhook Logs',
		description: '',
		link: '',
	},
	'mfa-factor-authentication': {
		label: 'MFA Factor Authentication',
		description: '',
		link: '',
	},
	'profile-information': {
		label: 'Profile Information',
		description: '',
		link: '',
	},
	'reset-pin': {
		label: 'Reset PIN',
		description: '',
		link: '',
	},
	'security': {
		label: 'Security',
		description: '',
		link: '',
	},
	'settings': {
		label: 'Settings',
		description: '',
		link: '',
	},
	'team-management': {
		label: 'Team Management',
		description: '',
		link: '',
	},
	'update-pin': {
		label: 'Update PIN',
		description: '',
		link: '',
	},
	'wallet': {
		label: 'Wallet',
		description: '',
		link: '',
	},
	'withdrawals': {
		label: 'Withdrawals',
		description: '',
		link: '',
	},
};

export const tooltipLinkMap: Record<string, { pageType: TooltipPageType; link: string }> = {
	'/home': { pageType: 'dashboard', link: '' },
	'/wallet': { pageType: 'wallet', link: '' },
	'/addresses': { pageType: 'addresses', link: '' },
	'/transactions': { pageType: 'transactions', link: '' },
	'/withdrawals': { pageType: 'withdrawals', link: '' },
	'/analytics': { pageType: 'analytics', link: '' },
	'/developer/integrations': { pageType: 'developer-integration', link: '' },
	'/developer/business': { pageType: 'developer-business', link: '' },
	'/developer/webhook-logs': { pageType: 'developer-webhook-logs', link: '' },
	'/settings': { pageType: 'settings', link: '' },
	'/settings/profile-information': { pageType: 'profile-information', link: '' },
	'/settings/crypto-settings': { pageType: 'crypto-settings', link: '' },
	'/settings/security': { pageType: 'security', link: '' },
	'/settings/security/update-pin': { pageType: 'update-pin', link: '' },
	'/settings/security/reset-pin': { pageType: 'reset-pin', link: '' },
	'/settings/security/mfa-factor-authentication': { pageType: 'mfa-factor-authentication', link: '' },
	'/settings/security/change-password': { pageType: 'change-password', link: '' },
	'/settings/security/activity-log': { pageType: 'activity-log', link: '' },
	'/settings/automatic-settlement': { pageType: 'automatic-settlement', link: '' },
	'/settings/team-management': { pageType: 'team-management', link: '' },
};
